<template>
    <section style="margin:18px;">
        <v-btn @click="OpenAddMiniProject">Add Project</v-btn>
        <v-btn @click="OpenProjectFiles">Add Project Files</v-btn>
        <v-btn @click="OpenProjectCurriculam">Add Project Curriculam </v-btn>
        <v-btn @click="AddProjectImageDialog">Add Project Banner</v-btn>
        <v-btn @click="AddProjectSEO">Add Project SEO</v-btn>
        <app-add-mini-projects ref="AddMiniProject" :dialog='AddMiniProject' @close='CloseDialog'></app-add-mini-projects>
        <app-project-files ref="AddMiniProjectFile" :dialog='ProjectFiles' @close='CloseDialog'></app-project-files>
        <app-add-project-curriculam ref="AddProjectCurriculam" :dialog='ProjectCurriculam' @close='CloseDialog'></app-add-project-curriculam>
        <app-project-banner ref="AddProjectBanner" :dialog='ProjectBanner' @close='CloseDialog'></app-project-banner>
        <app-Mini-Project-Seo ref="AddProjectSeo" :dialog='ProjectSEO' @close='CloseDialog'></app-Mini-Project-Seo>
        <app-project-table></app-project-table>
    </section>
</template>
<script>
import appAddMiniProjects      from '../views/dialogs/AddMiniProjects'
import appProjectFiles         from '../views/dialogs/AddVideoORZip'
import appAddProjectCurriculam from '../views/dialogs/AddMiniProjectCurriculam'
import appProjectBanner        from '../views/dialogs/AddProjectImage'
import appProjectTable         from '../views/tables/MiniProjectsTable'
import appMiniProjectSeo       from '../views/dialogs/AddProjectSEO'

export default {
    components:{
        appAddMiniProjects,
        appProjectFiles,
        appAddProjectCurriculam,
        appProjectTable,
        appProjectBanner,
        appMiniProjectSeo
    },
    data(){
        return {
            AddMiniProject    : false,
            ProjectFiles      : false,
            ProjectCurriculam : false,
            ProjectBanner     : false,
            ProjectSEO        : false
        }
    },
    methods:{
        OpenAddMiniProject(){

            this.$refs.AddMiniProject.GetMiniProjectCategoryList()
            this.AddMiniProject = true
        },
        OpenProjectFiles(){

            this.$refs.AddMiniProjectFile.GetMiniProjectList()
            this.ProjectFiles = true
        },
        OpenProjectCurriculam(){
            
            this.$refs.AddProjectCurriculam.GetMiniProjectList()
            this.ProjectCurriculam = true
        },
        AddProjectImageDialog(){
            this.$refs.AddProjectBanner.GetMiniProjectList()
            this.ProjectBanner = true
        },
        AddProjectSEO(){
            this.$refs.AddProjectSeo.GetProjectList()
            this.ProjectSEO = true
        },
        CloseDialog(){

            this.AddMiniProject = false
            this.ProjectFiles   = false
            this.ProjectCurriculam = false,
            this.ProjectBanner     = false,
            this.ProjectSEO        = false
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style scoped>

</style>